import React, { useState, useEffect } from 'react'
import { 
  ArrowLeft,
  Calendar,
  Edit,
  Search
} from 'lucide-react'
import { Breadcrumb } from '../../components/Common'
import { useNavigate, useLocation } from 'react-router-dom'

const ServiceMasterView = () => {
  const navigate = useNavigate()
  const location = useLocation()
  
  // Get the Service data from navigation state or URL params
  const serviceData = location.state?.serviceData || {
    id: 1,
    serviceCode: 'SER/0004',
    serviceDescription: 'Support & Maintenance',
    active: 'Yes',
    selectSAC: 'SAC001',
    gstRate: '18.00',
    igstRate: '18.00',
    cgstRate: '9.00',
    sgstRate: '9.00'
  }

  const [formData, setFormData] = useState({
    serviceCode: '',
    serviceDescription: '',
    active: 'Yes',
    selectSAC: '',
    gstRate: '',
    igstRate: '',
    cgstRate: '',
    sgstRate: ''
  })

  // Pre-fill form data when component mounts
  useEffect(() => {
    setFormData({
      serviceCode: serviceData.serviceCode || '',
      serviceDescription: serviceData.serviceDescription || '',
      active: serviceData.active || 'Yes',
      selectSAC: serviceData.selectSAC || '',
      gstRate: serviceData.gstRate || '',
      igstRate: serviceData.igstRate || '',
      cgstRate: serviceData.cgstRate || '',
      sgstRate: serviceData.sgstRate || ''
    })
  }, [serviceData])

  const handleBack = () => {
    navigate('/sales/service-master')
  }

  const handleEdit = () => {
    navigate('/sales/service-master/edit', { state: { serviceData } })
  }

  // Breadcrumb items
  const breadcrumbItems = [
    {
      label: 'Sales',
      path: '/sales',
      onClick: () => navigate('/sales')
    },
    {
      label: 'Masters',
      path: '/sales',
      onClick: () => navigate('/sales')
    },
    {
      label: 'Service Master',
      path: '/sales/service-master',
      isCurrent: true
    }
  ]

  return (
    <div className="sales-dashboard">
      {/* Breadcrumb Navigation */}
      <div className="breadcrumb-section">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      {/* Page Header */}
      <div className="page-header">
        <div className="page-title">
          <h1>Service Master - View</h1>
          <p>View service master data</p>
        </div>
        <div className="page-actions">
          <button className="btn-primary" onClick={handleEdit}>
            <Edit size={18} />
            Edit
          </button>
        </div>
      </div>

      {/* Form Section */}
      <div className="form-container">
        <div className="sac-form-header">
          <h2>Service Master</h2>
        </div>
          
        <div className="form-content">
          {/* Row 1: Service Code, Service Description, Active, Select SAC */}
          <div className="grid-row-4">
            <div className="form-group">
              <label className="form-label required">
                Service Code
              </label>
              <div className="form-input-readonly">
                {formData.serviceCode || 'N/A'}
              </div>
            </div>

            <div className="form-group">
              <label className="form-label required">
                Service Description
              </label>
              <div className="form-input-readonly">
                {formData.serviceDescription || 'N/A'}
              </div>
            </div>

            <div className="form-group">
              <label className="form-label required">
                Active
              </label>
              <div className="form-input-readonly">
                {formData.active || 'N/A'}
              </div>
            </div>

            <div className="form-group">
              <label className="form-label required">
                Select SAC
              </label>
              <div className="search-input-wrapper">
                <div className="form-input-readonly search-input">
                  {formData.selectSAC || 'N/A'}
                </div>
                <button
                  type="button"
                  className="search-button"
                  title="Search SAC"
                  disabled
                  style={{ opacity: 0.5, cursor: 'not-allowed' }}
                >
                  <Search size={16} />
                </button>
              </div>
            </div>
          </div>

          {/* Row 2: GST Rate, IGST Rate, CGST Rate, SGST Rate */}
          <div className="grid-row-4">
            <div className="form-group">
              <label className="form-label">
                GST Rate
              </label>
              <div className="form-input-readonly">
                {formData.gstRate ? `${formData.gstRate}%` : 'N/A'}
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">
                IGST Rate
              </label>
              <div className="form-input-readonly">
                {formData.igstRate ? `${formData.igstRate}%` : 'N/A'}
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">
                CGST Rate
              </label>
              <div className="form-input-readonly">
                {formData.cgstRate ? `${formData.cgstRate}%` : 'N/A'}
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">
                SGST Rate
              </label>
              <div className="form-input-readonly">
                {formData.sgstRate ? `${formData.sgstRate}%` : 'N/A'}
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="form-actions">
            <button
              type="button"
              onClick={handleBack}
              className="btn-secondary"
            >
              <ArrowLeft size={16} />
              Back
            </button>
            <button
              type="button"
              onClick={handleEdit}
              className="btn-primary"
            >
              <Edit size={16} />
              Edit
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ServiceMasterView